export default __webpack_public_path__ + "static/IKB_Logo_CMYK_Rot_Schwarz_300dpi-fff9b7266639c20d319590d41cae8a39.webp";